const benefits = [
  {
    icon: 'ri-settings-2-line',
    number: '01',
    title: 'Гибкость',
    text: 'Можно начать с малого — одной статьи или аватара — и постепенно перейти к полному управлению всеми соцсетями бренда.',
  },
  {
    icon: 'ri-ai-generate',
    number: '02',
    title: 'Технологичность',
    text: 'Использование ИИ-аватаров и нейро-копирайтинга делает ваш бренд инновационным в глазах клиентов и выделяет среди конкурентов.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    number: '03',
    title: 'Прозрачная экономика',
    text: 'Каждая услуга привязана к конкретному бизнес-показателю: охват, лид, продажа. Никакой «работы ради работы».',
  },
];

export default function SMMBenefits() {
  return (
    <section className="py-12 sm:py-20 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-hand-coin-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Для предпринимателя
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Почему это выгодно предпринимателю?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-8">
          {benefits.map((b) => (
            <div
              key={b.number}
              className="bg-white rounded-2xl p-6 sm:p-8 border border-[#E8DDD0] flex flex-col gap-4 hover:border-[#C5A880] transition-colors duration-300"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1A2B4C] flex-shrink-0">
                  <i className={`${b.icon} text-2xl text-[#C5A880]`}></i>
                </div>
                <span className="text-5xl font-extrabold text-[#1A2B4C]/05 font-['Playfair_Display'] select-none leading-none">
                  {b.number}
                </span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-snug">
                {b.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] text-justify flex-1">
                {b.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
